<template>
  <div class="card card-custom card-stretch gutter-b">
    <b-overlay :show="loading" variant="white" rounded="sm">
      <div class="card-body pt-3 pb-0">
        <div class="table-responsive">
          <div
            v-show="items.length == 0 && !loading"
            class="alert alert-custom alert-notice alert-light-warning fade show mb-5 mt-5"
            role="alert"
          >
            <div class="alert-icon">
              <i class="flaticon-warning"></i>
            </div>
            <div class="alert-text">
              <strong>Búsqueda sin resultados</strong>. Intente nuevamente
              buscando con otros parámetros.
            </div>
            <div class="alert-close"></div>
          </div>

          <table
            class="table table-head-custom table-vertical-center tabla-detalle-comision"
            v-show="items.length > 0 && !loading"
          >
            <thead>
              <tr class="text-left">
                <th style="min-width: 100px">Mes</th>
                <th style="min-width: 100px">Año</th>
                <th style="min-width: 130px">Comisiones Periodo</th>
                <th style="min-width: 100px">Enviar Boleta/Factura</th>
                <th style="min-width: 100px">Boleta/Factura</th>
                <th style="min-width: 100px">Aprobar</th>
                <th style="min-width: 130px">No Aprobar</th>
                <th style="min-width: 100px">Agente</th>
                <th style="min-width: 130px">Rut Corredor</th>
                <th style="min-width: 400px">Nombre Corredor</th>
                <th style="min-width: 130px">Estado</th>
                <th style="min-width: 130px">Motivo</th>
                <th style="min-width: 130px">N° Documento</th>
                <th style="min-width: 190px">Fecha Boleta Factura</th>
                <th style="min-width: 100px">Moneda</th>
                <th style="min-width: 140px">Tipo Cambio</th>
                <th style="min-width: 220px">Monto Comisión Afecta</th>
                <th style="min-width: 220px">Monto Comisión Exenta</th>
                <th style="min-width: 160px">Monto Afecta UF</th>
                <th style="min-width: 160px">Monto Exenta UF</th>
                <th style="min-width: 160px">Afecta Neto</th>
                <th style="min-width: 160px">Impuesto Afecta</th>
                <th style="min-width: 140px">Total Afecta</th>
                <th style="min-width: 140px">Exenta Neto</th>
                <th style="min-width: 160px">Impuesto Exenta</th>
                <th style="min-width: 140px">Total Exenta</th>
                <th style="min-width: 140px">Neto</th>
                <th style="min-width: 140px">Impuesto Total</th>
                <th style="min-width: 140px">Total a Girar</th>
               
                <th style="min-width: 150px">Fecha Creación</th>
                <th style="min-width: 180px">Fecha Actualización</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in items" v-bind:key="i">
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.Mes
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.Anio
                  }}</span>
                </td>
                <td class="pl-0 text-center">
                  <span
                    class="btn btn-icon btn-light btn-sm mx-3"
                    @click="modalDetalleLiquidacion(item)"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <svg
                        version="1.1"
                        viewBox="0 0 24 24"
                        height="24px"
                        width="24px"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title xmlns="http://www.w3.org/2000/svg">
                          Comisiones
                        </title>
                        <desc xmlns="http://www.w3.org/2000/svg" />
                        <defs xmlns="http://www.w3.org/2000/svg" />
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
                            fill="#000000"
                            opacity="0.3"
                          />
                          <path
                            d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
                            fill="#000000"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            x="10"
                            y="9"
                            width="7"
                            height="2"
                            rx="1"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            x="7"
                            y="9"
                            width="2"
                            height="2"
                            rx="1"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            x="7"
                            y="13"
                            width="2"
                            height="2"
                            rx="1"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            x="10"
                            y="13"
                            width="7"
                            height="2"
                            rx="1"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            x="7"
                            y="17"
                            width="2"
                            height="2"
                            rx="1"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            x="10"
                            y="17"
                            width="7"
                            height="2"
                            rx="1"
                          />
                        </g>
                      </svg>
                    </span>
                  </span>
                </td>
                <td
                  class="pl-0 text-center"
                  v-if="
                    item.Estado != 'EN PROCESO' && item.Estado != 'APROBADO'
                  "
                >
                  <span
                    class="btn btn-icon btn-light btn-sm mx-3"
                    @click="obtenerRetenciones(item)"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <svg
                        version="1.1"
                        viewBox="0 0 24 24"
                        height="24px"
                        width="24px"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title xmlns="http://www.w3.org/2000/svg">
                          Ver Detalle Comision
                        </title>
                        <desc xmlns="http://www.w3.org/2000/svg" />
                        <defs xmlns="http://www.w3.org/2000/svg" />
                        <g
                          xmlns="http://www.w3.org/2000/svg"
                          id="Stockholm-icons-/-General-/-Settings-1"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M7,3 L17,3 C19.209139,3 21,4.790861 21,7 C21,9.209139 19.209139,11 17,11 L7,11 C4.790861,11 3,9.209139 3,7 C3,4.790861 4.790861,3 7,3 Z M7,9 C8.1045695,9 9,8.1045695 9,7 C9,5.8954305 8.1045695,5 7,5 C5.8954305,5 5,5.8954305 5,7 C5,8.1045695 5.8954305,9 7,9 Z"
                            id="Combined-Shape"
                            fill="#000000"
                          />
                          <path
                            d="M7,13 L17,13 C19.209139,13 21,14.790861 21,17 C21,19.209139 19.209139,21 17,21 L7,21 C4.790861,21 3,19.209139 3,17 C3,14.790861 4.790861,13 7,13 Z M17,19 C18.1045695,19 19,18.1045695 19,17 C19,15.8954305 18.1045695,15 17,15 C15.8954305,15 15,15.8954305 15,17 C15,18.1045695 15.8954305,19 17,19 Z"
                            id="Combined-Shape"
                            fill="#000000"
                            opacity="0.3"
                          />
                        </g>
                      </svg>
                    </span>
                  </span>
                </td>
                <td class="pl-0 text-center" v-else>
                  <span
                    class="btn btn-icon btn-light btn-sm mx-3"
                    @click="avisoEnviado()"
                  >
                    <img
                      src="https://img.icons8.com/color/48/000000/check-file.png"
                      width="30"
                    />
                  </span>
                </td>
                <td class="pl-0 text-center">
                  <span
                    class="btn btn-icon btn-light btn-sm mx-3"
                    @click="descargarBoletaFactura(item)"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <svg
                        version="1.1"
                        viewBox="0 0 24 24"
                        height="24px"
                        width="24px"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title xmlns="http://www.w3.org/2000/svg">
                          Boleta Factura
                        </title>
                        <desc xmlns="http://www.w3.org/2000/svg" />
                        <defs xmlns="http://www.w3.org/2000/svg" />
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M2,13 C2,12.5 2.5,12 3,12 C3.5,12 4,12.5 4,13 C4,13.3333333 4,15 4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 C2,15 2,13.3333333 2,13 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                            opacity="0.3"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            transform="translate(12.000000, 8.000000) rotate(-180.000000) translate(-12.000000, -8.000000) "
                            x="11"
                            y="1"
                            width="2"
                            height="14"
                            rx="1"
                          />
                          <path
                            d="M7.70710678,15.7071068 C7.31658249,16.0976311 6.68341751,16.0976311 6.29289322,15.7071068 C5.90236893,15.3165825 5.90236893,14.6834175 6.29289322,14.2928932 L11.2928932,9.29289322 C11.6689749,8.91681153 12.2736364,8.90091039 12.6689647,9.25670585 L17.6689647,13.7567059 C18.0794748,14.1261649 18.1127532,14.7584547 17.7432941,15.1689647 C17.3738351,15.5794748 16.7415453,15.6127532 16.3310353,15.2432941 L12.0362375,11.3779761 L7.70710678,15.7071068 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                            transform="translate(12.000004, 12.499999) rotate(-180.000000) translate(-12.000004, -12.499999) "
                          />
                        </g>
                      </svg>
                    </span>
                  </span>
                </td>
                <td class="pl-0 text-center">
                  <span
                    class="btn btn-icon btn-light btn-sm mx-3"
                    @click="aprobarBoletaFactura(item, true)"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <svg
                        version="1.1"
                        viewBox="0 0 24 24"
                        height="24px"
                        width="24px"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title xmlns="http://www.w3.org/2000/svg">
                          Aprobar
                        </title>
                        <desc xmlns="http://www.w3.org/2000/svg" />
                        <defs xmlns="http://www.w3.org/2000/svg" />
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z"
                            fill="#000000"
                            opacity="0.3"
                          />
                          <path
                            d="M11.1750002,14.75 C10.9354169,14.75 10.6958335,14.6541667 10.5041669,14.4625 L8.58750019,12.5458333 C8.20416686,12.1625 8.20416686,11.5875 8.58750019,11.2041667 C8.97083352,10.8208333 9.59375019,10.8208333 9.92916686,11.2041667 L11.1750002,12.45 L14.3375002,9.2875 C14.7208335,8.90416667 15.2958335,8.90416667 15.6791669,9.2875 C16.0625002,9.67083333 16.0625002,10.2458333 15.6791669,10.6291667 L11.8458335,14.4625 C11.6541669,14.6541667 11.4145835,14.75 11.1750002,14.75 Z"
                            fill="#000000"
                          />
                        </g>
                      </svg>
                    </span>
                  </span>
                </td>
                <td class="pl-0 text-center">
                  <span
                    class="btn btn-icon btn-light btn-sm mx-3"
                    @click="aprobarBoletaFactura(item, false)"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <svg
                        version="1.1"
                        viewBox="0 0 24 24"
                        height="24px"
                        width="24px"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title xmlns="http://www.w3.org/2000/svg">
                          No Aprobar
                        </title>
                        <desc xmlns="http://www.w3.org/2000/svg" />
                        <defs xmlns="http://www.w3.org/2000/svg" />
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z"
                            fill="#000000"
                            opacity="0.3"
                          />
                          <path
                            d="M10.5857864,12 L9.17157288,10.5857864 C8.78104858,10.1952621 8.78104858,9.56209717 9.17157288,9.17157288 C9.56209717,8.78104858 10.1952621,8.78104858 10.5857864,9.17157288 L12,10.5857864 L13.4142136,9.17157288 C13.8047379,8.78104858 14.4379028,8.78104858 14.8284271,9.17157288 C15.2189514,9.56209717 15.2189514,10.1952621 14.8284271,10.5857864 L13.4142136,12 L14.8284271,13.4142136 C15.2189514,13.8047379 15.2189514,14.4379028 14.8284271,14.8284271 C14.4379028,15.2189514 13.8047379,15.2189514 13.4142136,14.8284271 L12,13.4142136 L10.5857864,14.8284271 C10.1952621,15.2189514 9.56209717,15.2189514 9.17157288,14.8284271 C8.78104858,14.4379028 8.78104858,13.8047379 9.17157288,13.4142136 L10.5857864,12 Z"
                            fill="#000000"
                          />
                        </g>
                      </svg>
                    </span>
                  </span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.CodigoAgente
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg"
                    >{{ item.RutCorredor }}-{{ item.RutCorredorDv }}</span
                  >
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.NombreCorredor
                  }}</span>
                </td>
                <td class="pl-0">
                  <span
                    :class="getColor(item.Estado)"
                    class="label label-lg label-inline font-weight-bold"
                  >
                    {{ capitalizar(item.Estado) }}
                  </span>
                </td>
                <td class="pl-0">
                  <span
                    v-if="item.Motivo != null"
                    class="text-dark-75 d-block font-size-lg"
                    >{{ capitalizar(item.Motivo) }}
                  </span>
                  <span v-else class="text-dark-75 d-block font-size-lg"
                    >-
                  </span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.NumeroDocumento
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-primary d-block font-size-lg">{{
                    item.FechaFacturacionBoleta != "0001-01-01T00:00:00-03:00"
                      ? formatearFecha(item.FechaFacturacionBoleta)
                      : "Sin Fecha"
                  }}</span>
                </td>
                <td class="pl-0">
                  <span
                    :class="getColor(item.Moneda)"
                    class="label label-lg label-inline font-weight-bold"
                  >
                    {{ item.Moneda }}
                  </span>
                </td>

                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearEuro(item.TipoCambio) 
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearEuro( item.MontoComisionAfecta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                     formatearEuro(item.MontoComisionExenta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                     formatearEuro(item.MontoAfectaUF)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                     formatearEuro(item.MontoExentaUF)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.AfectoNeto)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.ImpuestoAfecta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.TotalAfecta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.ExentoNeto)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.ImpuestoExenta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.TotalExenta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.Neto)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.ImpuestoTotal)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.TotalGirar)
                    
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-primary d-block font-size-lg texto-derecha">{{
                    item.FechaCreacion != "0001-01-01T00:00:00-03:00"
                      ? formatearFecha(item.FechaCreacion)
                      : "Sin Fecha"
                  }}</span>
                </td>

                <td class="pl-0">
                  <span class="text-primary d-block font-size-lg texto-derecha">{{
                    item.FechaCreacion != "0001-01-01T00:00:00-03:00"
                      ? formatearFecha(item.FechaActualizacion)
                      : "Sin Fecha"
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <v-pagination
          v-model="page"
          :length="pages"
          v-if="pages > 1"
          :total-visible="10"
          min="1"
          step="1"
        ></v-pagination>
      </div>
    </b-overlay>

    <div>
      <b-modal
        id="modal-detalle-comision"
        title="Liquidación de comisiones"
        hide-footer
        size="lg"
      >
        <DetalleComision :comision="comision" :retenciones="retenciones"></DetalleComision>
      </b-modal>
    </div>

    <div>
      <b-modal
        id="modal-rechazo"
        title="Ingresar Motivo de Rechazo"
        hide-footer
        size="sm"
      >
        <b-form-input
          maxlength="200"
          class="form-control"
          type="text"
          id="example-input-2"
          name="example-input-2"
          v-model="item.Motivo"
        ></b-form-input>
        <hr />
        <b-button @click="enviarRechazo" variant="info" class="m-1">
          Ok
        </b-button>
      </b-modal>
    </div>

    <div>
      <b-modal
        id="modal-detalle-liquidacion"
        title="Detalle Comisión"
        hide-footer
        size="xl"
        centered
      >
        <!-- <hr style="margin-top:-30px" /> -->
        <div class="d-flex lg-0">
          <button
            @click="onexport"
            class="btn btn-contempora btn-shadow btn-lg font-weight-bold mr-2"
            style="height: 45.1px; width: 160px"
          >
            <v-icon dark> mdi-file-excel </v-icon> Reporte
          </button>
        </div>
        <br />
        <div class="row">
          <v-data-table
            :headers="headersDetalleLiquidacion"
            :items="detalleLiquidacion"
            :items-per-page="5"
            class="elevation-2 tabla-codebase theme--light col"
            loading-text="Cargando... Espere Por favor"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Registros por página ',
              'items-per-page-all-text': 'Todas',
            }"
          >
            <template v-slot:[`item.fechaCreacion`]="item">
              {{ formatDate(item.item.fechaCreacion) }}
            </template>
            <template v-slot:[`item.moneda`]="item">
              <span
                :class="getColor(item.item.moneda)"
                class="label label-lg label-inline font-weight-bold"
              >
                {{ item.item.moneda }}
              </span>
            </template>
            <template v-slot:[`item.rutCorredor`]="item">
              {{ item.item.rutCorredor }} - {{ item.item.rutCorredorDv }}
            </template>
            <template v-slot:[`item.endoso`]="item">
              <span
                :class="getColor(item.item.endoso)"
                class="label label-lg label-inline font-weight-bold"
              >
                {{ item.item.endoso == true ? "Si" : "No" }}
              </span>
            </template>
            <template v-slot:[`item.primaNeta`]="item">          
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'UF'">
                {{ formatearUF(item.item.primaNeta)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'US$'">
                {{  formatearDolar(item.item.primaNeta)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'EUR'">
                {{  formatearEuro(item.item.primaNeta)  }} 
              </span>
            </template>
            <template v-slot:[`item.porcentajeComision`]="item">
              <span class="text-dark-75 d-block font-size-lg texto-derecha">
                {{item.item.porcentajeComision }} 
              </span>
            </template>        
            <template v-slot:[`item.montoComision`]="item">
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'UF'">
                {{ formatearUF(item.item.montoComision)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'US$'">
                {{  formatearDolar(item.item.montoComision)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'EUR'">
                {{  formatearEuro(item.item.montoComision)  }} 
              </span>            
            </template>
            <template v-slot:[`item.cambio`]="item">

              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'UF'">
                {{ formatearUF(item.item.cambio)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'US$'">
                {{  formatearDolar(item.item.cambio)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'EUR'">
                {{  formatearEuro(item.item.cambio)  }} 
              </span> 
            </template>
            <template v-slot:[`item.comisionNeta`]="item">
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'UF'">
                {{ formatearUF(item.item.comisionNeta)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'US$'">
                {{  formatearDolar(item.item.comisionNeta)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'EUR'">
                {{  formatearEuro(item.item.comisionNeta)  }} 
              </span> 
            </template>
            <template v-slot:[`item.impuesto`]="item">
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'UF'">
                {{ formatearUF(item.item.impuesto)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'US$'">
                {{  formatearDolar(item.item.impuesto)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'EUR'">
                {{  formatearEuro(item.item.impuesto)  }} 
              </span> 
            </template>
            <template v-slot:[`item.comisionTotal`]="item">
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'UF'">
                {{ formatearUF(item.item.comisionTotal)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'US$'">
                {{  formatearDolar(item.item.comisionTotal)  }} 
              </span>
              <span class="text-dark-75 d-block font-size-lg texto-derecha" v-if="item.item.moneda == 'EUR'">
                {{  formatearEuro(item.item.comisionTotal)  }} 
              </span>
            </template>
            <template v-slot:[`item.ajusteVersusFacturacion`]="item">
              <span class="text-dark-75 d-block font-size-lg texto-derecha">
                {{item.item.ajusteVersusFacturacion }} 
              </span>
            </template>
            <template v-slot:[`item.comisionAPago`]="item">
              <span class="text-dark-75 d-block font-size-lg texto-derecha">
                {{formatearEuro(item.item.comisionAPago) }} 
              </span>
            </template>
            <template v-slot:[`item.descuentoAnticipo`]="item">
              <span class="text-dark-75 d-block font-size-lg texto-derecha">
                {{item.item.descuentoAnticipo }} 
              </span>
            </template>
            <template v-slot:[`item.saldoAPagar`]="item">
              <span class="text-dark-75 d-block font-size-lg texto-derecha">
                {{item.item.saldoAPagar }} 
              </span>
            </template>    
            <template v-slot:[`item.fechaFacturacionBoleta`]="item">
              {{ formatDate(item.item.fechaFacturacionBoleta) }}
            </template>
            <template v-slot:[`item.estado`]="item">
              <span
                :class="getColor(item.item.estado)"
                class="label label-lg label-inline font-weight-bold"
              >
                {{ item.item.estado }}
              </span>
            </template>
            <template v-slot:[`item.tipoComision`]="item">
              <span
                :class="getColor(item.item.tipoComision)"
                class="label label-lg label-inline font-weight-bold"
              >
                {{ item.item.tipoComision }}
              </span>
            </template>

          </v-data-table>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import DetalleComision from "@/view/content/widgets/detalleComision/DetalleComision.vue";
import { GET_RETENCIONES } from "@/core/services/store/retencion.module";
import {
  GET_LIQUIDACION_ID,
  DESCARGAR_BOLETA_FACTURA,
  APROBAR_BOLETA_FACTURA,
} from "@/core/services/store/liquidacion.module";
import {
  GET_FACTURACION_COMISION,
  GET_FACTURACION_COMISION_PERIODO,
} from "@/core/services/store/facturacionComision.module";
import XLSX from "xlsx";
import moment from "moment";
export default {
  name: "dataTableWidget",
  components: {
    DetalleComision,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    loading: { type: Boolean, required: true },
    itemKey: String,
    customClickAction: Function,
    pagination: {
      type: Object,
      required: true,
    },
    pages: { type: Number, required: true },
    page : Number
  },
  watch: {
    page: {
      handler() {
        this.$emit("fetch-more", {
          page: this.page,
          page_size: this.pagination.page_size,
          filter: "",
        });
      },
      deep: true,
    }  
  },
  computed: {
    // pages () {
    //   //console.log(("registros: " + this.pagination.totalRecords + " , paginas " + this.page_size)
    //     return Math.ceil(this.pagination.totalRecords / this.page_size);
    // }
  },
  data() {
    return {
      retenciones: [],    
      page_size: this.pagination.page_size,
      comision: null,
      detalleLiquidacion: null,
      item: [],
      estado: null,
      filtroDetalleComision: {
        rutCorredor: "",
        mes: 0,
        anio: 0,
        codigoAgente:0
      },
      headersDetalleLiquidacion: [
        {
          text: "Fecha Creación",
          align: "start",
          sortable: true,
          value: "fechaCreacion",
          width: "170px",
        },
        {
          text: "Mes",
          align: "start",
          sortable: true,
          value: "mes",
          width: "100px",
        },
        {
          text: "Año",
          align: "start",
          sortable: true,
          value: "anio",
          width: "100px",
        },
        {
          text: "Moneda",
          align: "start",
          sortable: true,
          value: "moneda",
          width: "130px",
        },
        {
          text: "Sucursal",
          align: "start",
          sortable: true,
          value: "sucursal",
          width: "130px",
        },
        {
          text: "Rut Contratante",
          align: "start",
          sortable: true,
          value: "rutContratante",
          width: "150px",
        },
        {
          text: "Nombre Contratante",
          align: "start",
          sortable: true,
          value: "nombreContratante",
          width: "250px",
        },
        {
          text: "Código Ramo",
          align: "start",
          sortable: true,
          value: "codigoRamo",
          width: "170px",
        },
        {
          text: "Ramo Fecu",
          align: "start",
          sortable: true,
          value: "ramoFecu",
          width: "200px",
        },
        {
          text: "Póliza",
          align: "start",
          sortable: true,
          value: "poliza",
          width: "150px",
        },
        {
          text: "Endoso",
          align: "start",
          sortable: true,
          value: "endoso",
          width: "130px",
        },
        {
          text: "Prima Neta",
          align: "start",
          sortable: true,
          value: "primaNeta",
          width: "130px",
        },
        {
          text: "% Comisión",
          align: "start",
          sortable: true,
          value: "porcentajeComision",
          width: "150px",
        },
        {
          text: "Monto Comisión",
          align: "start",
          sortable: true,
          value: "montoComision",
          width: "170px",
        },
        {
          text: "Tipo Comisión",
          align: "start",
          sortable: true,
          value: "tipoComision",
          width: "150px",
        },
        {
          text: "Cambio",
          align: "start",
          sortable: true,
          value: "cambio",
          width: "100px",
        },
        {
          text: "Comisión Neta",
          align: "start",
          sortable: true,
          value: "comisionNeta",
          width: "170px",
        },
        {
          text: "Impuesto",
          align: "start",
          sortable: true,
          value: "impuesto",
          width: "130px",
        },
        {
          text: "Comisión Total",
          align: "start",
          sortable: true,
          value: "comisionTotal",
          width: "170px",
        },
        {
          text: "Ajuste v/s fact",
          align: "start",
          sortable: true,
          value: "ajusteVersusFacturacion",
          width: "150px",
        },
        {
          text: "Comisión A Pago",
          align: "start",
          sortable: true,
          value: "comisionAPago",
          width: "170px",
        },
        {
          text: "Descuento Anticipo",
          align: "start",
          sortable: true,
          value: "descuentoAnticipo",
          width: "150px",
        },
        {
          text: "Saldo A Pagar",
          align: "start",
          sortable: true,
          value: "saldoAPagar",
          width: "170px",
        },
        {
          text: "Tipo Documento",
          align: "start",
          sortable: true,
          value: "tipoDocumento",
          width: "170px",
        },
        {
          text: "N° Documento",
          align: "start",
          sortable: true,
          value: "numeroDocumento",
          width: "170px",
        },
        {
          text: "Fecha Fact/Boleta",
          align: "start",
          sortable: true,
          value: "fechaFacturacionBoleta",
          width: "170px",
        },
        {
          text: "Estado",
          align: "start",
          sortable: true,
          value: "estado",
          width: "130px",
        },
      ],
    };
  },
  created() {
    this.$bus.$on("resultadoSubirBoleta", (resultado) => {
      if (resultado && resultado == true) {
        this.$bvModal.hide("modal-detalle-comision");
        this.$bus.$emit("resultadoAprobar", true);
      }
    });
  },
  mounted() {

  },
  methods: {
    pesos(moneda) {
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 3,
      });
      let formato = monedaFormateada.format(moneda);
      return formato.replace("$", "").replace(",", ".");
    },
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },
    makeToast(append = false, texto, titulo, variant) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 5000,
        variant: variant,
        toaster: "b-toaster-top-right",
        appendToast: append,
      });
    },
    aprobarBoletaFactura(item, estado) {
      item.estado = "APROBADO";
      if (estado == false) {
        this.$bvModal.show("modal-rechazo");
        item.estado = "NO APROBADO";
        this.item = item;
        this.estado = estado;
      } else {
        this.$store
          .dispatch(APROBAR_BOLETA_FACTURA, item)
          .then((resultado) => {
            this.$bus.$emit("resultadoAprobar", true);
            this.makeToast(
              false,
              "Documento actualizado correctamente",
              "Aviso",
              "success"
            );
          })
          .catch((error) => {
            if (error.status == 406) {
              this.makeToast(
                false,
                "Factura o Boleta pendiente por corredor.",
                "Aviso",
                "warning"
              );
            } else {
              this.makeToast(
                false,
                "Ha currido un problema",
                "Aviso",
                "danger"
              );
            }
          });
      }
    },
    enviarRechazo() {
      this.$bvModal.hide("modal-rechazo");
      this.$store
        .dispatch(APROBAR_BOLETA_FACTURA, this.item)
        .then((resultado) => {
          this.$bus.$emit("resultadoAprobar", true);
          this.makeToast(
            false,
            "Documento actualizado correctamente",
            "Aviso",
            "success"
          );
        })
        .catch((error) => {
          if (error.status == 406) {
            this.makeToast(
              false,
              "Factura o Boleta pendiente por corredor.",
              "Aviso",
              "warning"
            );
          } else {
            this.makeToast(false, "Ha currido un problema", "Aviso", "danger");
          }
        });
    },
    onexport() {
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 3,
      });
      this.$store
        .dispatch(GET_FACTURACION_COMISION_PERIODO, this.filtroDetalleComision)
        .then((response) => {
          let archivoSalida = [];
          response.forEach((element) => {
            //Armamos el formato de salida
            let comision = {
              fechaCreacion: element.fechaCreacion.split("T")[0],
              mes: element.mes,
              anio: element.anio,
              moneda: element.moneda,
              sucursal: element.sucursal,
              rutContratante: element.rutContratante,
              nombreContratante: element.nombreContratante,
              codigoRamo: element.codigoRamo,
              ramoFecu: element.ramoFecu,
              poliza: element.poliza,
              endoso: element.endoso,
              primaNeta: element.primaNeta,
              porcentajeComision: element.porcentajeComision,
              montoComision: element.montoComision,
              tipoComision: element.tipoComision,
              cambio: element.cambio,
              comisionNeta: Math.round(element.comisionNeta),
              impuesto: Math.round(element.impuesto),
              comisionTotal: Math.round(element.comisionTotal),
              ajusteVersusFactura: element.ajusteVersusFactura,
              comisionAPago: element.comisionAPago,
              descuentoAnticipo: element.descuentoAnticipo,
              saldoAPagar: element.saldoAPagar,
              tipoDocumento: element.tipoDocumento,
              numeroDocumento: element.numeroDocumento,
              fechaFacturaBoleta: element.fechaFacturaBoleta,
              estado: element.estado,
            };
            archivoSalida.push(comision);
          });
          const archivo =
            "DetalleComisiones_" + new Date().toISOString().substr(0, 10);
          var conciliaciones = [];
          conciliaciones = XLSX.utils.json_to_sheet(archivoSalida);
          var libro = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(
            libro,
            conciliaciones,
            "DetalleComisiones"
          );
          XLSX.writeFile(libro, `${archivo}.xlsx`);
        });
    },
    descargarBoletaFactura(item) {
      this.$store
        .dispatch(DESCARGAR_BOLETA_FACTURA, item.LiquidacionId)
        .then((resultado) => {
          if (resultado != null && resultado.length > 0) {
            let tipoDocumento = "";
            resultado.forEach((element) => {
              if (element == "AFECTA") {
                tipoDocumento = element;
              } else if (element == "EXENTA") {
                tipoDocumento = element;
              } else if (tipoDocumento != "") {
                const url = `data:application/pdf;base64,${element}`;
                const descargar = document.createElement("a");
                const nombreDocumento = `${item.RutCorredor}_${item.CodigoAgente}_${item.Mes}_${item.Anio}_${tipoDocumento}.pdf`;

                tipoDocumento = "";
                descargar.href = url;
                descargar.download = nombreDocumento;
                descargar.click();
                this.makeToast(
                  false,
                  "Documento Descargado",
                  "Aviso",
                  "success"
                );
              }
            });
          } else {
            this.makeToast(
              false,
              "Ha currido un error o el documento no existe",
              "Aviso",
              "danger"
            );
          }
        })
        .catch((error) => {
          this.makeToast(
            false,
            "Ha currido un problema al descargar el documento",
            "Aviso",
            "danger"
          );
        });
    },

    avisoEnviado() {
      this.makeToast(false, "El documento ya fue envíado", "Aviso", "info");
    },
    
    obtenerRetenciones(item) {
      this.$store.dispatch(GET_RETENCIONES).then((response) => {
        this.retenciones = response;
        this.modalDetalleComision(item)
      });
    },
    modalDetalleComision(item) {
      // const submitButton = this.$refs["btn_archivos"];
      // submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store
        .dispatch(GET_LIQUIDACION_ID, {
          liquidacionId: item.LiquidacionId,
        })
        .then((resultado) => {
          this.comision = resultado;

          // this.comision.estado = item.Estado;
          // this.comision.facturacionComisionId = item.FacturacionComisionId;
          // this.$bus.$emit("resultadoSubida", true);
          this.$bvModal.show("modal-detalle-comision");
          // submitButton.classList.remove(
          //   "spinner",
          //   "spinner-light",
          //   "spinner-right"
          // );
        })
        .catch((resultado) => {
          //   submitButton.classList.remove(
          //     "spinner",
          //     "spinner-light",
          //     "spinner-right"
          //   );
        });
    },
    modalDetalleLiquidacion(item) {
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 3,
      });
      // const submitButton = this.$refs["btn_archivos"];
      // submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store
        .dispatch(GET_FACTURACION_COMISION_PERIODO, {
          rutCorredor: item.RutCorredor,
          mes: item.Mes,
          anio: item.Anio,
          codigoAgente: item.CodigoAgente
        })
        .then((resultado) => {
          this.detalleLiquidacion = resultado;

          // resultado.forEach((element) => {
          //   // element.comisionNeta = monedaFormateada
          //   //   .format(element.comisionNeta.toFixed(3))
          //   //   .replace("$", "")
          //   //   .replace(",", ".");
          //   element.comisionTotal = monedaFormateada
          //     .format(element.comisionTotal.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", ".");
          //   element.comisionAPago = monedaFormateada
          //     .format(element.comisionAPago.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", ".");
          // });

          //Guardamos el fitrlo en data, para utilizarlos en la descarga del reporte
          this.filtroDetalleComision.rutCorredor = item.RutCorredor;
          this.filtroDetalleComision.mes = item.Mes;
          this.filtroDetalleComision.anio = item.Anio;
          this.filtroDetalleComision.codigoAgente = item.CodigoAgente;

          // this.detalleLiquidacion.comisionNeta =
          // console.log(this.detalleLiquidacion);
          // this.comision.facturacionComisionId = item.FacturacionComisionId;
          // this.$bus.$emit("resultadoSubida", true);
          if (resultado.length > 0) {
            this.$bvModal.show("modal-detalle-liquidacion");
            this.makeToast(false, "Registros cargados", "Aviso", "success");
          } else {
            this.makeToast(false, "No hay Registros", "Aviso", "danger");
          }

          // submitButton.classList.remove(
          //   "spinner",
          //   "spinner-light",
          //   "spinner-right"
          // );
        })
        .catch((resultado) => {
          //   submitButton.classList.remove(
          //     "spinner",
          //     "spinner-light",
          //     "spinner-right"
          //   );
        });
    },
    formatearPesos(moneda) {
      let monedaFormateada = new Intl.NumberFormat("es-CL");

      return monedaFormateada.format(moneda);
    },
    formatearDolar(moneda) {
      let monedaFormateada = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits : 2
      });

      return monedaFormateada.format(moneda).replace("$", "");
    },
    formatearEuro(moneda) {
      let monedaFormateada = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });

      return monedaFormateada.format(moneda).replace("€", "");
    },
    formatearUF(moneda) {
      let monedaFormateada = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 5,
      });

      return monedaFormateada.format(moneda).replace("€", "");
    },
    getColor(valor) {
      if (valor == "PAGADO") return "label-light-success";
      else if (valor == "EN PROCESO") return "label-warning";
      else if (valor == "NO PAGADO") return "label-light-danger";
      else if (valor == "FACTURA") return "label-light-success";
      else if (valor == "NO APROBADO") return "label-light-danger";
      else if (valor == "APROBADO") return "label-success";
      else if (valor == "BOLETA") return "label-light-primary";
      else if (valor == true) return "label-light-success";
      else if (valor == false) return "label-light-danger";
      else if (valor == "UF") return "label-light-success";
      else if (valor == "UTM") return "label-light-primary";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "Afecta") return "label-light-danger";
      else if (valor == "Excenta") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else return "label-light-success";
    },
    capitalizar(valor) {
      if (valor != null) {
        let texto = valor.toLowerCase();
        return texto.charAt(0).toUpperCase() + texto.slice(1);
      }
    },
    formatearFecha(fecha) {
      var fechaFormateada = moment(fecha).format("DD/MM/YYYY");
      return fechaFormateada;
    },
    getPercent(item) {
      return Math.round(
        (item.TotalArchivosCargados / item.TotalArchivos) * 100
      );
    },
    getVariantType(item) {
      let porcentaje = this.getPercent(item);
      if (porcentaje == 100) {
        return "success";
      } else if (porcentaje >= 50) {
        return "warning";
      } else if (porcentaje > 30) {
        return "primary";
      }
      return "danger";
    },
  },
};
</script>

<style>
.tabla-detalle-comision th {
  font-size: 10px !important;
}

.texto-derecha {
  text-align: right;
}
</style>
